import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './tooltip.component';
import { TextModule } from '../text/text.module';
import { IconModule } from '../icon/icon.module';
import { ModalModule } from '../modal/modal.module';
import { ModalHeaderModule } from '../modal/modal-header.module';
import { ModalContentModule } from '../modal/modal-content.module';
import { ModalFooterModule } from '../modal/modal-footer.module';
import { ButtonModule } from '../button/button.module';
import { CloseActionModule } from '../close-action/close-action.module';
@NgModule({
  declarations: [TooltipComponent],
  imports: [
    CommonModule,
    TextModule,
    IconModule,
    ModalModule,
    ModalHeaderModule,
    ModalContentModule,
    ButtonModule,
    ModalFooterModule,
    CloseActionModule,
  ],
  exports: [TooltipComponent],
})
export class TooltipModule {}
